import { BookingStatus, Language, Priority, UserInfo } from "../constants/options";
import { USER_INFO } from "../constants/storage-keys";
import useStores from "../hooks/use-stores";
import { GetLocalStorage } from "./cryptography";
import { isWeb } from "./platform";

export const IS_SMALL_SCREEN = isWeb ? window.innerWidth <= 1024 : false;
export const IsAuthed = () => {
  return isWeb && localStorage.USER_TOKEN != null && localStorage.USER_INFO != null;
};

export const GetLanguage = () => {
  return (isWeb && localStorage.LANG) ? localStorage.LANG : Language.ENGLISH;
};

export const GetLanguageLabel = () => {
  return (isWeb && localStorage.LANG) ? localStorage.LANG == Language.ENGLISH ? 'English'
    : localStorage.LANG == Language.ZH_HK ? '繁體中文 (香港)'
      : localStorage.LANG == Language.ZH_TW ? '繁體中文 (台灣)'
        : '简体中文' : 'English';
};

export const GetCurrency = () => {
  return (isWeb && localStorage.LANG && localStorage.LANG === Language.ZH_CN) ? '￥' : '$';
};

export const GetBookingStatus = (statusId: number) => {
  if (statusId == BookingStatus.REJECTED) return "Rejected";
  if (statusId == BookingStatus.APPROVED) return "Approved";
  if (statusId == BookingStatus.PENDING) return "Pending";
  if (statusId == BookingStatus.CANCELLED) return "Cancelled";
};

export const ConvertLangKeyToLabel = (lang: Language) => {
  return lang === Language.ENGLISH ? 'English' :
    lang === Language.ZH_CN ? '简体中文' :
      lang === Language.ZH_HK ? '繁體中文 (香港)'
        : '繁體中文 (台灣)';
};



export const ConvertListToCommonOptions = (infoList: any[], fieldId: string, fieldLabel: string, extraField?: string) => {
  // @ts-ignore
  return infoList.map((info: any) => ({ id: info[fieldId], label: info[fieldLabel], extraField: info[extraField] }));
};

export const GetPriority = (priorityId: number) => {
  if (priorityId === Priority.LOW) return 'Low';
  if (priorityId === Priority.MEDIUM) return 'Medium';
  if (priorityId === Priority.HIGH) return 'High';
};

export const GetPriorityList = () => {
  return [
    { id: Priority.LOW, label: "Low" },
    { id: Priority.MEDIUM, label: "Medium" },
    { id: Priority.HIGH, label: "High" },
  ];
};

export const GetErrorInfo = (err: any) => {
  //err is err:obj
  console.log(err);
  if (err.message === "ERR_CANCELED") {
    // DO NOTHING, THIS IS A CANCELLED REQUEST
    return "";
  } else if (err.message.includes("Network error!")) {
    return "Failed to connect to server.";
  } else if (err.name === "AxiosError") {
    if (err.response.status === 404) return "404 Resource Not Found";
    else if (err.response.status === 400) return "Invalid request format";
  } else if (err.name === "TypeError") {
    return `Error: ${err.message}`;
  } else if (!err.response || !err.response.data.message)
    return "Unknown error for VAI Server. Please contact the administrator.";
  let input = err.response.data.message;
  const regex = /Error:/g;
  let match: RegExpExecArray | null;
  let lastMatchIndex = -1;
  while ((match = regex.exec(input)) !== null) {
    lastMatchIndex = match.index;
  }
  if (lastMatchIndex !== -1) {
    return input.substring(lastMatchIndex + "Error:".length).trim();
  }
  return "Unknown error for VAI Server. Please contact the administrator.";
};

export const Resident_Category_Id = 3;

export const CNDateTimeFormat = "YYYY-MM-DD HH:mm";
export const CNDateFormat = "YYYY-MM-DD";
export const AUDateTimeFormat = "DD/MM/YYYY hh:mm A";
export const AUDDateFormat = "DD/MM/YYYY";
export const AUDTimeFormat = "hh:mm A";

// Fail Description
export const UPDATE_FAILED_MSG = "Update failed, please try again or contact admin";
export const DELETE_FAILED_MSG = "Delete failed, please try again or contact admin";
export const CREATE_FAILED_MSG = "Create failed, please try again or contact admin";
export const EMAIL_SEND_FAILED_MSG = "Email sent failed, please try again or contact admin";
export const PREVIEW_EMAIL_FAILED_MSG = "This is email is unable to preview, please try again or contact admin";